import React, { useRef, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SimpleBarReact from 'simplebar-react';
import TextareaAutosize from 'react-textarea-autosize';
import ChattingMessage from './ChattingMessage';
import { dateDatabase, dateFormatFull } from 'utils/FormatDate'

const ChattingForm = ({
    show,
    handleClose,
    handleChange,
    scrollToBottom,
    setScrollToBottom,
    message,
    dataMessage,
    dataConversation,
    sendMessage,
    handleConfirm
}) => {
    const messagesEndRef = useRef();
    let lastDate = null;

    useEffect(() => {
        if (scrollToBottom) {
            if(messagesEndRef.current){
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                setScrollToBottom(false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollToBottom]);

    return (
        <>
            <SimpleBarReact style={{ height: '80%', width: '50%' }} className="mx-auto">
                {
                    dataMessage ? dataMessage.map((val, idx) => {
                        return (
                            <div key={idx}>
                                {lastDate !== dateDatabase(val.dtadd) && (
                                    <div className="text-center fs--2 text-500">{dateDatabase(val.dtadd) === dateDatabase ? `Today` : `${dateFormatFull(val.dtadd)}`}</div>
                                )}
                                {(() => {
                                    lastDate = dateDatabase(val.dtadd);
                                })()}
                                <ChattingMessage left={parseFloat(val.intis_admin) === 0} message={val.vcmessage} date={val.dtadd} />
                            </div>
                        )
                    }) : ''
                }
                <div ref={messagesEndRef} />
            </SimpleBarReact>
            <div className={parseFloat(dataConversation.intstatus) === 2 ? "text-center fs--2 text-500 mt-3" : "d-none"}>
                Percakapan sudah diakhiri
            </div>
            <Form className={parseFloat(dataConversation.intstatus) === 2 ? "d-none" : "chat-editor-area mx-auto mt-3"} style={{ width: '50%' }} >
                <TextareaAutosize
                    minRows={1}
                    maxRows={6}
                    value={message}
                    placeholder="Type your message"
                    onChange={(e) => handleChange(e, 'message')}
                    className="form-control outline-none resize-none rounded-0 border-0 emojiarea-editor"
                />

                <Button
                    variant="send"
                    size="sm"
                    className={'text-primary'}
                    onClick={sendMessage}
                >
                    Send
                </Button>
            </Form>
            
            <Row className="mt-4">
                <Col md={{ size: 6, offset: 3 }}>
                    <Button size="sm" className={parseFloat(dataConversation.intstatus) === 2 ? "d-none" : "float-end me-2"} variant="primary" onClick={() => handleConfirm('endChat', dataConversation.intid, dataConversation.intstatus)}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Akhiri Percakapan
                    </Button>

                    <Button size="sm" className="float-end me-2" variant="secondary" onClick={handleClose}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                </Col>
                <Col md="3"></Col>
            </Row>
        </>
        // <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} fullscreen={true} size="xl">
        //     <Modal.Header className="bg-card-gradient light border-bottom-0">
        //         <Modal.Title className="text-white">ChattingForm Data</Modal.Title>
        //     <FalconCloseButton onClick={handleClose} variant="white" />
        //     </Modal.Header>
        //         <Modal.Body>
                    
        //         </Modal.Body>
        //         <Modal.Body>
        //         </Modal.Body>
        //     <Modal.Footer>
        //         <Button className={parseFloat(dataConversation.intstatus) === 2 ? "d-none" : ""} variant="primary" onClick={() => handleConfirm('endChat', dataConversation.intid, dataConversation.intstatus)}>
        //             <FontAwesomeIcon icon={faTimes} className="me-2" /> Akhiri Percakapan
        //         </Button>
        //         <Button variant="secondary" onClick={handleClose}>
        //             <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
        //         </Button>
        //     </Modal.Footer>
        // </Modal>
    );
}

ChattingForm.propTypes = {}

export default ChattingForm;